import { MultiLanguageTextModel } from './MultiLanguageTextModel';

export class PartnerModel {
  private _id: string;
  private _name: string;
  private _websiteUrl: string;
  private _description: MultiLanguageTextModel;
  private _htmlDescription: string | null;

  private _logo: string;

  private _email: string | null;
  private _phone: string | null;
  private _address: string | null;

  /**
   * Keys the public partner profile experience (/partner/{code}). Assigned
   * after construction (not a constructor param, to keep the signature stable).
   */
  partnerCode: string | null = null;

  constructor(
    id: string,
    name: string,
    websiteUrl: string,
    description: MultiLanguageTextModel,
    logo: string,

    email: string | null,
    phone: string | null,
    address: string | null,
    htmlDescription: string | null = null
  ) {
    this._id = id;
    this._name = name;
    this._websiteUrl = websiteUrl;
    this._description = description;
    this._logo = logo;

    this._email = email;
    this._phone = phone;
    this._address = address;
    this._htmlDescription = htmlDescription;
  }

  get id() {
    return this._id;
  }
  get name() {
    return this._name;
  }
  get description() {
    return this._description;
  }
  get htmlDescription() {
    return this._htmlDescription;
  }
  get websiteUrl() {
    return this._websiteUrl;
  }
  get logo() {
    return this._logo;
  }
  get email() {
    return this._email || '';
  }
  get phone() {
    return this._phone || '';
  }
  get address() {
    return this._address || '';
  }
}
